import { clientV3SDK } from "@istari-frontend/api-client";
import { V3Models } from "@istari/istari-client";
import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";

import { DEFAULT_CACHE_TIME } from "~/constants";

const LIST_PAGE_SIZE = 20;

export type WorkflowLogFilters = {
  title?: string;
  branchId?: string;
  archiveStatus?: V3Models.ArchiveStatus;
};

export const workflowLogQueryKeys = {
  all: (systemId: string) => ["workflow-log", systemId],
  listInfinite: (systemId: string, filters?: WorkflowLogFilters) => [
    ...workflowLogQueryKeys.all(systemId),
    "list",
    "infinite",
    filters ?? {},
  ],
  detail: (systemId: string, entryId: string) => [...workflowLogQueryKeys.all(systemId), "detail", entryId],
};

export const workflowLogQueryOptions = {
  listInfinite: (systemId: string, filters?: WorkflowLogFilters) =>
    infiniteQueryOptions({
      queryKey: workflowLogQueryKeys.listInfinite(systemId, filters) as unknown[],
      queryFn: async ({ pageParam }: { pageParam: string | undefined }) =>
        clientV3SDK.listWorkflowLogEntries({
          systemId,
          cursor: pageParam ?? undefined,
          size: LIST_PAGE_SIZE,
          includeTotal: true,
          ...(filters?.title ? { title: [filters.title] } : {}),
          ...(filters?.branchId ? { branchId: [filters.branchId] } : {}),
          ...(filters?.archiveStatus ? { archiveStatus: filters.archiveStatus } : {}),
        }),
      initialPageParam: undefined as string | undefined,
      getNextPageParam: (lastPage) => lastPage.nextPage ?? undefined,
      staleTime: DEFAULT_CACHE_TIME,
    }),
  detail: (systemId: string, entryId: string) =>
    queryOptions({
      queryKey: workflowLogQueryKeys.detail(systemId, entryId),
      queryFn: () => clientV3SDK.getWorkflowLogEntry({ systemId, entryId }),
      enabled: !!systemId && !!entryId,
      staleTime: DEFAULT_CACHE_TIME,
    }),
};
